import React, { FC } from 'react';
import { Dialog, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ImportedDeleteProgressProps {
  done: number;
  total: number;
}

const TITLE_ID = 'imported-delete-progress-title';

/** A modal that cannot be dismissed: the admin must see that a deletion is under way. */
export const ImportedDeleteProgress: FC<ImportedDeleteProgressProps> = ({ done, total }) => {
  const { t } = useTranslation('components');
  const text = t('PageTreeBulkOperations.deleteImportedProgress', { done, total });
  return (
    <Dialog open maxWidth='xs' fullWidth aria-labelledby={TITLE_ID}>
      <DialogTitle id={TITLE_ID}>{t('PageTreeBulkOperations.deleteImportedTitle')}</DialogTitle>
      <DialogContent>
        <LinearProgress variant='determinate' value={total ? (done / total) * 100 : 0} aria-label={text} />
        <Typography variant='body2' role='status' sx={{ mt: 1 }}>
          {text}
        </Typography>
        <Typography variant='caption' color='textSecondary'>
          {t('PageTreeBulkOperations.deleteImportedHint')}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ImportedDeleteProgress;
